import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo, useState } from "react";
import { FiHeart } from "@react-icons/all-files/fi/FiHeart";
import { IconComment } from "components/Icon";
import { FiShare2 } from "@react-icons/all-files/fi/FiShare2";
import ShareModal from "components/ShareModal/ShareModal";
import "./_style.scss";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
import ReactionsButton from "../ReactionsButton/ReactionsButton";
const stripShareFromUrl = () => {
    if (!/\/share\/?$/.test(window.location.pathname)) {
        return;
    }
    const basePath = window.location.pathname.replace(/\/share\/?$/, "");
    const { search, hash } = window.location;
    window.history.replaceState(null, "", (basePath || "/") + search + hash);
};
const CampaignUpdateFooter = forwardRef(({ commentAnchorId, showComments, onToggleComments, update, campaign, onReactionsChange, isCommentsEnabled, showShareOnOpen, onShareModalClose, }, ref) => {
    const [shareOpen, setShareOpen] = useState(!!showShareOnOpen);
    const { translateChoice: tChoice } = useLanguageProvider();
    const donateUrl = useMemo(() => `/pay/campaign/${campaign.id}?utm_source=campaign_update&utm_content=${update.id}`, [campaign.id, update.id]);
    const shareUrl = useMemo(() => {
        const baseUrl = document.URL
            .replace(/\/updates\/[^/]+.*$/, "")
            .replace(/^(https?:\/\/[^/]+)\/campaign\//, "$1/project/");
        return `${baseUrl}/updates/${update.id}`;
    }, [update.id]);
    const commentCountLabel = useMemo(() => {
        const count = update.commentsCount;
        const commentLabel = tChoice("Comment|Comments", count);
        return `${count} ${commentLabel}`;
    }, [update.commentsCount, tChoice]);
    return (_jsxs("footer", { className: "campaign-update__footer", ref: ref, children: [_jsxs("div", { className: "campaign-update__actions", id: commentAnchorId, children: [_jsxs("div", { className: "campaign-update__actions-left", children: [_jsx(ReactionsButton, { update: update, onReactionsChange: onReactionsChange }), isCommentsEnabled && (_jsxs("button", { className: `campaign-update__comment-toggle${showComments ? " --expanded" : ""}`, onClick: onToggleComments, "aria-expanded": showComments, "aria-label": "Toggle comments", type: "button", children: [_jsx(IconComment, { width: "13px", height: "13px" }), update.commentsCount > 0 ? commentCountLabel : "Comment"] }))] }), _jsxs("div", { className: "campaign-update__actions-right", children: [_jsxs("button", { type: "button", className: "campaign-update__share-btn", onClick: () => setShareOpen(true), children: [_jsx(FiShare2, {}), "Share"] }), _jsxs("a", { href: donateUrl, className: "campaign-update__donate-btn", children: [_jsx(FiHeart, {}), "Donate"] })] })] }), _jsx(ShareModal, { isOpen: shareOpen, onClose: () => {
                    setShareOpen(false);
                    stripShareFromUrl();
                    onShareModalClose === null || onShareModalClose === void 0 ? void 0 : onShareModalClose();
                }, url: shareUrl })] }));
});
export default CampaignUpdateFooter;
